(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
    function makeSVGsWhite() {
  const svgs = document.querySelectorAll('svg');
  svgs.forEach(svg => {
    svg.setAttribute('fill', '#FFFFFF');
    svg.setAttribute('stroke', '#FFFFFF');

    const paths = svg.querySelectorAll('path, circle, rect, line, polyline, polygon, ellipse');

    paths.forEach(path => {
      path.setAttribute('fill', '#FFFFFF');
      path.setAttribute('stroke', '#FFFFFF');
    });
  });
}
makeSVGsWhite();

function appendSearchToMenu() {
    // Get the element with class 'header__search'
    const searchElement = document.querySelector('.header__search');
    
    // Get the element with class 'header__inline-menu'
    const inlineMenuElement = document.querySelector('.header__inline-menu');
    
    // Check if both elements exist
    if (searchElement && inlineMenuElement) {
        // Append the search element to the inline menu element
        inlineMenuElement.appendChild(searchElement);
    } else {
        console.error('One or both of the elements could not be found.');
    }
}
appendSearchToMenu()

  function appendDrawerToMenu() {
    const headerDrawer = document.createElement('div');
    headerDrawer.setAttribute('data-breakpoint', 'desktop');
    headerDrawer.innerHTML = `
        <details id="Details-menu-drawer-container" class="menu-drawer-container">
            <summary class="header__icon header__icon--menu header__icon--summary link focus-inset" aria-label="Menu" role="button" aria-expanded="false" aria-controls="menu-drawer">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-hamburger" fill="none" viewBox="0 0 18 16">
                        <path d="M1 .5a.5.5 0 100 1h15.71a.5.5 0 000-1H1zM.5 8a.5.5 0 01.5-.5h15.71a.5.5 0 010 1H1A.5.5 0 01.5 8zm0 7a.5.5 0 01.5-.5h15.71a.5.5 0 010 1H1a.5.5 0 01-.5-.5z" fill="currentColor"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                        <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
                    </svg>
                </span>
            </summary>
            <div id="menu-drawer" class="gradient menu-drawer motion-reduce" tabindex="-1">
                <div class="menu-drawer__inner-container">
                    <div class="menu-drawer__navigation-container">
                        <nav class="menu-drawer__navigation">
                            <ul class="list-menu list-menu--inline" role="list"></ul>
                        </nav>
                        <div class="menu-drawer__utility-links">
                            <a href="/account/login" class="menu-drawer__account link focus-inset h5 medium-hide large-up-hide">
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-account" fill="none" viewBox="0 0 18 19">
                                    <path d="M6 4.5a3 3 0 116 0 3 3 0 01-6 0zm3-4a4 4 0 100 8 4 4 0 000-8zm5.58 12.15c1.12.82 1.83 2.24 1.91 4.85H1.51c.08-2.6.79-4.03 1.9-4.85C4.66 11.75 6.5 11.5 9 11.5s4.35.26 5.58 1.15zM9 10.5c-2.5 0-4.65.24-6.17 1.35C1.27 12.98.5 14.93.5 18v.5h17V18c0-3.07-.77-5.02-2.33-6.15-1.52-1.1-3.67-1.35-6.17-1.35z" fill="currentColor"></path>
                                </svg> Log in
                            </a>
                            <ul class="list list-social list-unstyled" role="list">
                                <li class="list-social__item"><a href="https://twitter.com" class="list-social__link link"><svg aria-hidden="true" focusable="false" class="icon icon-twitter" viewBox="0 0 18 15"><path fill="currentColor" d="M17.64 2.6a7.33 7.33 0 01-1.75 1.82c0 .05 0 .13.02.23l.02.23a9.97 9.97 0 01-1.69 5.54c-.57.85-1.24 1.62-2.02 2.28a9.09 9.09 0 01-2.82 1.6 10.23 10.23 0 01-8.9-.98c.34.02.61.04.83.04 1.64 0 3.1-.5 4.38-1.5a3.6 3.6 0 01-3.3-2.45A2.91 2.91 0 004 9.35a3.47 3.47 0 01-2.02-1.21 3.37 3.37 0 01-.8-2.22v-.03c.46.24.98.37 1.58.4a3.45 3.45 0 01-1.54-2.9c0-.61.14-1.2.45-1.79a9.68 9.68 0 003.2 2.6 10 10 0 004.08 1.07 3 3 0 01-.13-.8c0-.97.34-1.8 1.03-2.48A3.45 3.45 0 0112.4.96a3.49 3.49 0 012.54 1.1c.8-.15 1.54-.44 2.23-.85a3.4 3.4 0 01-1.54 1.94c.74-.1 1.4-.28 2.01-.54z"></path></svg><span class="visually-hidden">Twitter</span></a></li>
                                <li class="list-social__item"><a href="https://facebook.com" class="list-social__link link"><svg aria-hidden="true" focusable="false" class="icon icon-facebook" viewBox="0 0 18 18"><path fill="currentColor" d="M16.42.61c.27 0 .5.1.69.28.19.2.28.42.28.7v15.44c0 .27-.1.5-.28.69a.94.94 0 01-.7.28h-4.39v-6.7h2.25l.31-2.65h-2.56v-1.7c0-.4.1-.72.28-.93.18-.2.5-.32 1-.32h1.37V3.35c-.6-.06-1.27-.1-2.01-.1-1.01 0-1.83.3-2.45.9-.62.6-.93 1.44-.93 2.53v1.97H7.04v2.65h2.24V18H.98c-.28 0-.5-.1-.7-.28a.94.94 0 01-.28-.7V1.59c0-.27.1-.5.28-.69a.94.94 0 01.7-.28h15.44z"></path></svg><span class="visually-hidden">Facebook</span></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </details>
    `;

    // Append the header-drawer element to the element with class 'header__inline-menu'
    const inlineMenuElement = document.querySelector('.header__inline-menu');
    if (inlineMenuElement) {
        inlineMenuElement.insertBefore(headerDrawer, inlineMenuElement.firstChild);
    } else {
        console.error("Element with class 'header__inline-menu' not found.");
    }
}
appendDrawerToMenu()
const megaMenu = document.querySelector('.mega-menu');
const detailsMenuDrawer = document.querySelector('.header__inline-menu').children[0];

// Add click event to the entire details element
detailsMenuDrawer.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent default summary toggle behavior
    
    if (megaMenu) {
        megaMenu.classList.toggle('mega-menu--open'); // Toggle mega menu visibility
        
            if (document.body.style.overflow == "hidden") {
      document.body.style.overflow = "auto"
    } else {
              document.body.style.overflow = "hidden";
    }
    }
});

const menuItemDiv = document.querySelector('.list-menu');
megaMenu.appendChild(menuItemDiv);

document.addEventListener('DOMContentLoaded', function() {
    document.querySelector('.header__inline-menu').children[1].style.display = "none";
});

  const headerDrawer = document.querySelector('header-drawer');
if (headerDrawer) {
    headerDrawer.remove(); // Removes the entire header-drawer element from the DOM
}


  } catch(e) { console.error(e); }
})();
})();
